<template>
  <div>
    <button @click.prevent="$emit('toggleSummary')"
            class="inline-block text-left md:px-1 rounded-sm focus:outline-none">
      <svg
        :class="{ rotated: showSummary }"
        class="rotatable h-5 w-5 inline-block"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
      <div class="inline-block text-xl">Summary</div>
    </button>
  </div>
</template>

<script>

export default {
  name: 'PriceSummaryToggle',
  props: ['showSummary'],
  methods: {
    toggleSummary() {
      this.showSummary = !this.showSummary;
    }
  }
};
</script>
